import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class SitesService {
  constructor(private http: HttpClient) {}

  getSites() {
    return this.http.get('/api/data/sites');
  }

  getSite(id) {
    return this.http.get(`/api/data/sites/${id}`);
  }

  createSite(data): Observable<any> {
    return this.http.post('/api/data/sites', data);
  }

  updateSite(data): Observable<any> {
    return this.http.put(`/api/data/sites/${data.id}`, data);
  }

  addProductToSite(siteId, data): Observable<any> {
    return this.http.post(`/api/data/products/${siteId}`, data);
  }
}